import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

export default function PickupOrderPage() {

  const { orderId } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {

    const token = localStorage.getItem("accessToken");

    // ❌ No token → Stay here (NO redirect)
    if (!token) {
      setError("Please login to view order");
      return;
    }

    loadOrder();

  }, []);


  const loadOrder = async () => {

    try {

      const res = await axiosInstance.get(
        `/orders/${orderId}/`
      );

      setOrder(res.data);

    } catch {

      setError("Unable to load order");

    }

  };


  if (error) {
    return (
      <div style={{ padding: 30, textAlign: "center" }}>
        <h3>{error}</h3>

        <button
          onClick={() => navigate("/login")}
          style={btn}
        >
          Login
        </button>
      </div>
    );
  }


  if (!order) return <p>Loading...</p>;


  return (

    <div style={box}>

      <h2>🏬 Store Pickup Order</h2>

      <p><b>Order:</b> #{order.id}</p>
      <p><b>Amount:</b> ₹{order.payable_amount}</p>
      <p><b>Status:</b> {order.status}</p>

      <hr />

      <p>
        📍 Please collect from store counter
      </p>

      <p>
        ⏰ Opening Hours: 9AM - 9PM
      </p>

    </div>
  );
}


/* styles */

const box = {
  maxWidth: 400,
  margin: "auto",
  marginTop: 40,
  padding: 25,
  background: "#fff",
  borderRadius: 10,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
};

const btn = {
  padding: "10px 18px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
  marginTop: 15
};
